import { useTranslation } from "react-i18next"

const CardDocumentoAsociadoMsgDocumento = ({
  documentosAsociadosMsg,
  colorSelected,
}: {
  documentosAsociadosMsg: string
  colorSelected: string
}) => {
  const { t } = useTranslation()
  return (
    <div className='tw-flex tw-flex-col'>
      <div
        style={{ backgroundColor: colorSelected }}
        className='tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-h-12 tw-rounded-t-md tw-px-4 tw-text-simple-10'
      >
        {t("crear.facturaRec.partnersDocumentLabel")}
      </div>

      <div className='tw-flex tw-flex-col tw-px-8 tw-py-4 tw-text-left'>
        {documentosAsociadosMsg}
      </div>
    </div>
  )
}

export default CardDocumentoAsociadoMsgDocumento
